/**
 * Colours & Formats: default slide is the first “custom enquiry” block; only those rows toggle
 * slides and list active state. Rows with data-format-shows-active="false" (e.g. solid) ignore clicks.
 * Loaded with defer from the section — DOM is ready when this runs.
 */
function rowShowsActive(li) {
  return li.getAttribute('data-format-shows-active') === 'true';
}

function setActive(root, index) {
  const items = root.querySelectorAll('.product-colours-formats__item');
  const slides = root.querySelectorAll('[data-format-slide]');
  const buttons = root.querySelectorAll('.product-colours-formats__format-btn');

  items.forEach((li, i) => {
    const on = i === index && rowShowsActive(li);
    li.classList.toggle('is-active', on);
  });
  buttons.forEach((btn, i) => {
    const li = btn.closest('.product-colours-formats__item');
    const pressed = i === index && li && rowShowsActive(li);
    btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
  });
  slides.forEach((slide, i) => {
    const on = i === index;
    slide.classList.toggle('is-active', on);
    slide.setAttribute('aria-hidden', on ? 'false' : 'true');
  });
}

function init(root) {
  if (root.getAttribute('data-pcf-init') === '1') return;
  root.setAttribute('data-pcf-init', '1');

  root.querySelectorAll('.product-colours-formats__format-btn').forEach((btn) => {
    btn.addEventListener(
      'click',
      (e) => {
        const li = btn.closest('.product-colours-formats__item');
        if (!li || !rowShowsActive(li)) {
          e.preventDefault();
          return;
        }
        const raw = btn.getAttribute('data-format-index');
        const idx = raw == null ? NaN : parseInt(raw, 10);
        if (Number.isNaN(idx)) return;
        setActive(root, idx);
      },
      true
    );
  });
}

function boot() {
  document.querySelectorAll('[data-product-colours-formats]').forEach(init);
}

boot();
